var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchNormal = function SvgSearchNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2C4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 9.501a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5M11 11 9 9"
  })));
};
export default SvgSearchNormal;